
















































import { defineComponent, ref, onUpdated, computed } from '@vue/composition-api';
// @ts-ignore
import SearchIcon from '@/assets/icons/search.svg';
import SharedState from '@/data/SharedState';
export default defineComponent({
  components: {
    SearchIcon
  },
  props: {
    searchInput: {
      type: String,
      default: undefined
    },
    searchIsOpen: {
      type: Boolean,
      default: false
    }
  },
  emits: {
    search: (value: string) => value.length > 0,
    close: () => true,
    open: () => true,
  },
  setup(props, context) {
    const isActive = ref(false);
    const inputHasFocus = ref(false);
    const inputField = ref<HTMLInputElement|null>(null);
    const inputFieldValue = ref('');
    let searchOpened = false;
    
    const isActiveC = computed(() => {
      return isActive.value && props.searchIsOpen;
    });

    const openSearch = () => {
      
      context.emit('open');
      searchOpened = true;
      if(inputField.value) inputField.value.focus();
    }
    const closeSearch = () => {
      context.emit('close');
      searchOpened = false;
    }

    const onFocus = (hasFocus: boolean) => {
      inputHasFocus.value = hasFocus;
    };

    const getSearchTerms = (expression: string): Array<string> => {
      if(!expression.includes('"')) {
        return expression.split(' ');
      }
      return expression.split('"').filter(word => {
        return word.trim() !== '';
      });
    }

    const doSearch = () => {
      if(inputFieldValue.value) {
        context.emit('search', getSearchTerms(inputFieldValue.value));
      }
    };

    const placeHolderTextC = computed(() => {
      return SharedState.getText(context, 'corptube.search.placeholder');
    });

    const onTextChanged = () => {
      if(inputField.value) { 
        inputFieldValue.value = inputField.value.value;
      }
    };

    onUpdated(() => {
      if(searchOpened && inputField.value) {
        inputField.value.focus();
        searchOpened = false;
      }
    });

    return {
      isActiveC,
      openSearch,
      closeSearch,
      inputHasFocus,
      onFocus,
      inputField,
      doSearch,
      placeHolderTextC,
      onTextChanged,
      inputFieldValue
    };
  }
});
  
